import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import LabelFont from '../../Theme/Fonts/Label'
import Badge from '../../BaseComponents/Badges'
import { TestID } from '../../utils/PropTypesDefinitions'
import LinkProps from '../../Link/LinkProps'
import withFeatureDiscovery from '../../utils/withFeatureDiscovery'
import { WithFeatureDiscoveryProps } from '../../utils/withFeatureDiscovery/WithFeatureDiscoveryProps'

export type BottomNavigationItemProps = {
    type: BottomNavigationItemType
    caption: string
    badgeCount?: number
    onPress?: () => void
    href?: string
    active?: boolean
} & LinkProps &
    TestID &
    WithFeatureDiscoveryProps

type BottomNavigationItemType =
    | 'HOME'
    | 'SPORTS'
    | 'LIVESCORES'
    | 'TVVIDEO'
    | 'MORE'
    | 'NEWSTICKER'
    | 'TV'

const typeIconMapping: Map<BottomNavigationItemType, string> = new Map([
    ['HOME', 'home'],
    ['SPORTS', 'sports'],
    ['LIVESCORES', 'live'],
    ['TVVIDEO', 'media'],
    ['MORE', 'more'],
    ['NEWSTICKER', 'time'],
    ['TV', 'tv'],
])

const BottomNavigationItem: FunctionComponent<BottomNavigationItemProps> = ({
    type,
    caption,
    onPress,
    active,
    badgeCount = 0,
    href,
    testID,
    webRel,
}): ReactElement => {
    const icon = typeIconMapping.get(type)

    return (
        <Grid
            horizontal
            centerHorizontal
            testID={testID}
            opacity={active ? 1 : 0.7}
            backgroundColor="BLACK"
        >
            <Touchable onPress={onPress} href={href} webRel={webRel}>
                <Grid noExpand center>
                    <Grid
                        noExpand
                        position="relative"
                        height={20}
                        centerVertical
                        marginTop="7px"
                        marginBottom="3px"
                    >
                        {badgeCount > 0 ? (
                            <Grid noExpand zIndex={2} position="absolute" right={-8} top={-4}>
                                <Badge backgroundColor="ORANGE">{badgeCount}</Badge>
                            </Grid>
                        ) : null}
                        <FontelloIcon
                            name={`${icon}${active ? '-active' : ''}`}
                            fontSize={19}
                            color="WHITE"
                        />
                    </Grid>
                    <Grid noExpand>
                        <LabelFont color="WHITE" bold={active} allowFontScaling={false}>
                            {caption}
                        </LabelFont>
                    </Grid>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(withFeatureDiscovery(BottomNavigationItem))
